import { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import UECard from "../UECard";
import ModalPopup from "../ModalPopup";
import { readCurrentState, sendCurrentState, StepContext } from "../StepContext";
import pagoPa from "../../img/loghi-pagopa_Io.png"

var msgText = '';
var msgTitle = '';

function Step6() {
    const [modalShow, setModalShow] = useState(false);

    const [codiceCatastale, setCodiceCatastale] = useState("");
    const [subalterno, setSubalterno] = useState("");
    const [sezione, setSezione] = useState("");
    const [particella, setParticella] = useState("");
    const [foglio, setFoglio] = useState("");
    const [categoria, setCategoria] = useState("");

    const { step, setStep } = useContext(StepContext);

    useEffect(() => {
        setCodiceCatastale(readCurrentState("codiceCatastale"));
        setSubalterno(readCurrentState("subalterno"));
        setSezione(readCurrentState("sezione"));
        setParticella(readCurrentState("particella"));
        setFoglio(readCurrentState("foglio"));
        setCategoria(readCurrentState("categoria"));
    }, []);

    function Validation() {
        let conx = {};

        conx = {
            step: step,
            codiceCatastale: codiceCatastale.trim(),
            subalterno: subalterno.trim(),
            sezione: sezione.trim(),
            particella: particella.trim(),
            foglio: foglio.trim(),
            categoria: categoria.trim()
        };

        StepContext.contratto = { ...StepContext.contratto, ...conx };
        sendCurrentState();

        return true;
    }

    return (
        <UECard BackButton={true} NextButton={true} className="S1Div" style={{ marginLeft: "250px", width: "100%", textAlign: "center", marginTop: "50px" }} onValidate={Validation}>
            <h2 style={{ color: "green" }}>Se hai a disposizione i dati catastali inseriscili qui, altrimenti potrai farlo anche successivamente dal sito o dall'app MyUmbriaEnergy</h2>
            <br />
            <Container className="container-fluid">
                <Row className="justify-content-center text-left" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="numero" >
                            Codice Catastale<br />
                            <input type="text" className="ue ue-text" id="numero" placeholder="Codice Catastale" maxLength="4"
                                value={codiceCatastale} onChange={(e) => { setCodiceCatastale(e.target.value.toUpperCase()) }} />
                        </label>
                    </Col>
                </Row>
                <Row className="justify-content-center text-left" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="numero" >
                            Sezione<br />
                            <input type="text" className="ue ue-text" id="numero" placeholder="Sezione" maxLength="6"
                                value={sezione} onChange={(e) => { setSezione(e.target.value.toUpperCase()) }} />
                        </label>

                    </Col>
                </Row>
                <Row className="justify-content-center text-left" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="numero" >
                            Foglio<br />
                            <input type="text" className="ue ue-text" id="numero" placeholder="Foglio" maxLength="4"
                                value={foglio} onChange={(e) => { setFoglio(e.target.value.toUpperCase()) }} />
                        </label>
                    </Col>
                </Row>
                <Row className="justify-content-center text-left" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="numero" >
                            Particella<br />
                            <input type="text" className="ue ue-text" id="numero" placeholder="Particella" maxLength="4"
                                value={particella} onChange={(e) => { setParticella(e.target.value.toUpperCase()) }} />
                        </label>

                    </Col>
                </Row>
                <Row className="justify-content-center text-left" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="numero" >
                            Subalterno<br />
                            <input type="text" className="ue ue-text" id="numero" placeholder="Subalterno" maxLength="4"
                                value={subalterno} onChange={(e) => { setSubalterno(e.target.value.toUpperCase()) }} />
                        </label>
                    </Col>
                </Row>
                <Row className="justify-content-center text-left" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="numero" >
                            Categoria<br />
                            <input type="text" className="ue ue-text" id="numero" placeholder="Categoria" maxLength="4"
                                value={categoria} onChange={(e) => { setCategoria(e.target.value.toUpperCase()) }} />
                        </label>
                    </Col>
                </Row>
            </Container>
            <ModalPopup title={msgTitle} message={msgText} show={modalShow} onHide={() => setModalShow(false)} />

        </UECard>

    );
}

export default Step6